var _classCallCheck = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/neveragain_jail/home/neveragain/django/neveragain/frontend/node_modules/@babel/runtime/helpers/createClass");

var document = require('../document');

var URL = require('url-parse');

function unescapeKey(key) {
  if (key.match(/__(type|meta)$/)) {
    return key.substring(1);
  }

  return key;
}

function getString(obj, key) {
  var value = obj[key];

  if (typeof value === 'string') {
    return value;
  }

  return '';
}

function getBoolean(obj, key) {
  var value = obj[key];

  if (typeof value === 'boolean') {
    return value;
  }

  return false;
}

function getObject(obj, key) {
  var value = obj[key];

  if (typeof value === 'object') {
    return value;
  }

  return {};
}

function getArray(obj, key) {
  var value = obj[key];

  if (value instanceof Array) {
    return value;
  }

  return [];
}

function getContent(data, baseUrl) {
  var excluded = ['_type', '_meta'];
  var content = {};

  for (var property in data) {
    if (data.hasOwnProperty(property) && !excluded.includes(property)) {
      var key = unescapeKey(property);
      var value = primitiveToNode(data[property], baseUrl);
      content[key] = value;
    }
  }

  return content;
}

function primitiveToNode(data, baseUrl) {
  var isObject = data instanceof Object && !(data instanceof Array);

  if (isObject && data._type === 'document') {
    // Document
    var meta = getObject(data, '_meta');
    var relativeUrl = getString(meta, 'url');
    var url = relativeUrl ? URL(relativeUrl, baseUrl).toString() : '';
    var title = getString(meta, 'title');
    var description = getString(meta, 'description');
    var content = getContent(data, url);
    return new document.Document(url, title, description, content);
  } else if (isObject && data._type === 'link') {
    // Link
    var _relativeUrl = getString(data, 'url');

    var _url = _relativeUrl ? URL(_relativeUrl, baseUrl).toString() : '';

    var method = getString(data, 'action') || 'get';

    var _title = getString(data, 'title');

    var _description = getString(data, 'description');

    var fieldsData = getArray(data, 'fields');
    var encoding = getString(data, 'encoding') || 'application/json';
    var fields = [];

    for (var idx = 0, len = fieldsData.length; idx < len; idx++) {
      var value = fieldsData[idx];
      var name = getString(value, 'name');
      var required = getBoolean(value, 'required');
      var location = getString(value, 'location');
      var fieldDescription = getString(value, 'fieldDescription');
      var field = new document.Field(name, required, location, fieldDescription);
      fields.push(field);
    }

    return new document.Link(_url, method, encoding, fields, _title, _description);
  } else if (isObject) {
    // Object
    var _content = {};

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        _content[key] = primitiveToNode(data[key], baseUrl);
      }
    }

    return _content;
  } else if (data instanceof Array) {
    // Object
    var _content2 = [];

    for (var _idx = 0, _len = data.length; _idx < _len; _idx++) {
      _content2.push(primitiveToNode(data[_idx], baseUrl));
    }

    return _content2;
  } // Primitive


  return data;
}

var CoreJSONCodec =
/*#__PURE__*/
function () {
  "use strict";

  function CoreJSONCodec() {
    _classCallCheck(this, CoreJSONCodec);

    this.mediaType = 'application/coreapi+json';
  }

  _createClass(CoreJSONCodec, [{
    key: "decode",
    value: function decode(text) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = text;

      if (options.preloaded === undefined || !options.preloaded) {
        data = JSON.parse(text);
      }

      return primitiveToNode(data, options.url);
    }
  }]);

  return CoreJSONCodec;
}();

module.exports = {
  CoreJSONCodec: CoreJSONCodec
};